import { axios } from '@Root/API'

export const postLoginPassword = (login, password, code) => {
  return axios.post('login', { email: login, password, code })
}
